import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const lrScheduleComponent: ComponentDef = {
  id: 'lr-schedule',
  name: 'LR Schedule',
  description: 'Learning rate warmup, cosine decay, step decay, linear decay, and WSD schedules.',
  category: 'training',
  params: [
    { name: 'steps', label: 'Training steps', type: 'number', default: 10000, min: 100, max: 1000000, step: 100 },
    {
      name: 'variant',
      label: 'Schedule',
      type: 'select',
      default: 'cosine',
      options: [
        { label: 'Warmup + Cosine', value: 'cosine' },
        { label: 'Step Decay', value: 'step' },
        { label: 'Constant', value: 'constant' },
        { label: 'Linear', value: 'linear' },
        { label: 'WSD (Warmup-Stable-Decay)', value: 'wsd' }
      ]
    }
  ],
  buildGraph: (params) => {
    const steps = Number(params.steps);
    const variant = String(params.variant || 'cosine');

    const g = new GraphBuilder();
    g.input('step', [steps]);

    if (variant === 'linear') {
      // Linear decay: lr = lr_max * (1 - step / total_steps) after warmup
      g.scale('warmup', 'step', 'Warmup');
      g.scale('linear_decay', 'warmup', 'lr_max · (1 − t/T)');
      g.metric('lr', 'linear_decay', 'learning_rate');
      g.output('out', 'lr');

    } else if (variant === 'wsd') {
      // WSD: Warmup → Stable (constant lr) → Decay (sqrt or exponential)
      g.scale('warmup', 'step', 'Phase 1: Warmup');
      g.scale('stable', 'warmup', 'Phase 2: Stable (lr_max)');
      g.scale('decay', 'stable', 'Phase 3: Decay (1 − √((t−t_s)/(T−t_s)))');
      g.metric('lr', 'decay', 'learning_rate');
      g.output('out', 'lr');

    } else {
      // Existing schedules: cosine, step, constant
      g.scale('warmup', 'step', 'Warmup');
      g.scale('decay', 'warmup', String(params.variant));
      g.metric('lr', 'decay', 'learning_rate');
      g.output('out', 'lr');
    }

    return g.build();
  }
};
